import React, { useState, useEffect } from 'react';
import '../CSS/Enquiry.css';
import { submitEnquiry } from '../firebase/firestoreService';

const COURSES = [
  'SSC (Maharashtra Board)',
  'CBSE (Class V–X)',
  'Science / JEE Preparation',
  'NEET / AIIMS Preparation',
  'MH-CET Coaching',
  'Commerce (XI–XII)',
  'Career Counselling',
  'Other',
];

const Enquiry = () => {
  const [form, setForm] = useState({ name: '', phone: '', email: '', course: '', message: '' });
  const [status, setStatus] = useState(''); // 'loading' | 'success' | 'error'

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      await submitEnquiry(form);
      setStatus('success');
      setForm({ name: '', phone: '', email: '', course: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <>
      {/* Page Banner */}
      <div className="ngt-page-banner">
        <h1>Enquiry</h1>
        <p>We'd love to hear from you. Fill in the form and our team will respond promptly.</p>
      </div>

      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Enquiry</li>
        </ol>
      </nav>

      <section className="ngt-enquiry-page">
        <div className="container">
          <div className="row g-4 align-items-start">
            {/* Form */}
            <div className="col-lg-7">
              <h2 className="section-title text-start" style={{ textAlign: 'left' }}>
                Submit an Enquiry
              </h2>
              <hr className="ngt-divider" />
              <div className="ngt-enquiry-form-wrap">
                {status === 'success' && (
                  <div className="ngt-alert-success mb-4">
                    <i className="fas fa-check-circle me-2"></i>
                    Thank you! Your enquiry has been submitted. We will contact you within 24 hours.
                  </div>
                )}
                {status === 'error' && (
                  <div className="ngt-alert-error mb-4">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    Something went wrong. Please try again or call us directly.
                  </div>
                )}

                <form onSubmit={handleSubmit} noValidate>
                  <div className="row g-3">
                    <div className="col-md-6 form-group">
                      <label className="ngt-label" htmlFor="enq-name">Full Name *</label>
                      <input id="enq-name" name="name" type="text" className="ngt-form-control"
                        placeholder="e.g. Rahul Sharma" value={form.name}
                        onChange={handleChange} required />
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="ngt-label" htmlFor="enq-phone">Mobile Number *</label>
                      <input id="enq-phone" name="phone" type="tel" className="ngt-form-control"
                        placeholder="+91 XXXXX XXXXX" value={form.phone}
                        onChange={handleChange} required pattern="[0-9+\s\-]{10,15}" />
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="ngt-label" htmlFor="enq-email">Email Address</label>
                      <input id="enq-email" name="email" type="email" className="ngt-form-control"
                        placeholder="your@email.com" value={form.email}
                        onChange={handleChange} />
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="ngt-label" htmlFor="enq-course">Course of Interest *</label>
                      <select id="enq-course" name="course" className="ngt-form-control"
                        value={form.course} onChange={handleChange} required>
                        <option value="">— Select a Course —</option>
                        {COURSES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="col-12 form-group">
                      <label className="ngt-label" htmlFor="enq-message">Your Message</label>
                      <textarea id="enq-message" name="message" rows="5" className="ngt-form-control"
                        placeholder="Please share any specific questions, your child's current grade, or any other details that may help us assist you better."
                        value={form.message} onChange={handleChange}></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn-ngt-primary w-100"
                        style={{ padding: '13px', fontSize: '1rem', letterSpacing: '0.06em' }}
                        disabled={status === 'loading'}>
                        {status === 'loading'
                          ? <><i className="fas fa-spinner fa-spin me-2"></i>Submitting…</>
                          : <><i className="fas fa-paper-plane me-2"></i>Submit Enquiry</>}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Info Panel */}
            <div className="col-lg-5">
              <div className="ngt-enquiry-info">
                <h4>Get in Touch</h4>
                <div className="info-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <strong>Century Branch</strong><br />
                    Deshmukh Plaza, Murbad Road,<br />
                    Opp Century School, Ulhasnagar – 421002
                  </div>
                </div>
                <div className="info-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <strong>Khemani Branch</strong><br />
                    Near Jhulelal School, Khemani,<br />
                    Ulhasnagar – 421004
                  </div>
                </div>
                <div className="info-item">
                  <i className="fas fa-phone"></i>
                  <a href="tel:+919272136659" style={{ color: 'inherit' }}>+91 9272136659</a>
                </div>
                <div className="info-item">
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:ngt.mailer@gmail.com" style={{ color: 'inherit' }}>ngt.mailer@gmail.com</a>
                </div>
                <div className="info-item">
                  <i className="fab fa-whatsapp"></i>
                  <a href="https://wa.me/+919272136659" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                    Chat on WhatsApp
                  </a>
                </div>
                <div className="info-item">
                  <i className="fas fa-clock"></i>
                  Monday – Saturday: 7:00 AM – 8:00 PM
                </div>

                <hr style={{ borderColor: 'rgba(255,255,255,0.15)', margin: '1.5rem 0' }} />
                <h4 style={{ fontSize: '1rem', marginBottom: '0.8rem' }}>Courses Available</h4>
                {COURSES.slice(0, 6).map(c => (
                  <div key={c} style={{ fontSize: '0.88rem', marginBottom: '0.4rem' }}>
                    <i className="fas fa-chevron-right me-2" style={{ color: 'var(--ngt-gold)' }}></i>{c}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Enquiry;
